import { Contact } from '../../../models';
export function contactViewToContact(contactView) {
  var isIndividual = /^[A-Z][A-Z]INDIVIDUAL$|^INDIVIDUAL$/.test(contactView.entityType.id);
  return new Contact(contactView.id, contactView.displayAs, contactView.isClientCenterEnabled, isIndividual, contactView.givenName, contactView.familyName, contactView.primaryEmail.emailAddress, undefined, contactView.nickname, contactView.entityType);
}
